import { useCallback, useEffect, useState } from 'react';
import createUseContext from 'constate';
import { isArray, isEmpty } from 'lodash';

const SHOPPING_CART_LOCAL_STORAGE_KEY = 'EC_SHOPPING_CART';

const useShoppingCart = () => {
  const [shoppingCart, setShoppingCart] = useState([]);

  useEffect(() => {
    const rawData = localStorage.getItem(SHOPPING_CART_LOCAL_STORAGE_KEY);

    try {
      setShoppingCart(JSON.parse(rawData || '[]'));
    } catch (e) {
      localStorage.setItem(SHOPPING_CART_LOCAL_STORAGE_KEY, '[]');
      setShoppingCart([]);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(SHOPPING_CART_LOCAL_STORAGE_KEY, JSON.stringify(shoppingCart));
    } catch (e) {
      // ignore the error
      console.log(e.message);
    }
  }, [shoppingCart]);

  const addItem = useCallback((data) => {
    if (isEmpty(data)) return;
    if (!isArray(data)) {
      addItem([data]);
      return;
    }

    setShoppingCart((oldShoppingCart) => [
      ...oldShoppingCart,
      ...data.map(({
        key,
        name,
        provider,
        providerKey,
        price,
        sellPrice,
        images,
        specs,
      }) => ({
        key,
        name,
        provider,
        providerKey,
        price,
        sellPrice,
        specs,
        ...(
          images && images.length > 0
            ? { images: [images[0]] }
            : {}
        ),
      })),
    ]);
  }, []);

  const removeItem = useCallback((itemsToRemove) => {
    if (isEmpty(itemsToRemove)) return;
    if (!isArray(itemsToRemove)) {
      removeItem([itemsToRemove]);
      return;
    }

    setShoppingCart(
      shoppingCart.filter((item) => !itemsToRemove.includes(item))
    );
  }, [shoppingCart]);

  return {
    shoppingCart,
    addItem,
    removeItem,
  };
};

const [ShoppingCartProvider, useShoppingCartContext] = createUseContext(useShoppingCart);

export {
  ShoppingCartProvider,
  useShoppingCartContext,
};
